import { merge } from '../helper';

import * as exElement from './element';
import * as exIcon from './icon';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {
        list: [],
    };

    // If using title
    if (defConfig.title != null) {
        // If title is string
        if (typeof defConfig.title === 'string') {
            defConfig.title = {
                html: defConfig.title,
            };
        }

        // Create element (title)
        const elTitle = exElement.create({
            merge: defConfig.title,
            tag: 'span',
        });
        elements.title = elTitle;

        //
        elements.list.push(elTitle);
    }

    // If using icon
    if (defConfig.icon != null) {
        // If icon is string
        if (typeof defConfig.icon === 'string') {
            defConfig.icon = {
                type: defConfig.icon,
            };
        }

        // Create element (icon)
        const elIcon = exIcon.create({
            merge: defConfig.icon,
        });
        elements.icon = elIcon;

        //
        elements.list.push(elIcon);
    }

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function change(element: HTMLElement, config: Record<string, any> = {}): void {
    // Default Config
    const defConfig: Record<string, any> = {
        queryTitle: 'span',
        queryIcon: 'i',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // If using title
    if (defConfig.title != null) {
        // Get element (title)
        const elTitle = element.querySelector(defConfig.queryTitle);
        elTitle.innerHTML = defConfig.title;
    }

    // If using icon
    if (defConfig.icon != null) {
        // Get element (icon)
        const elIcon = element.querySelector(defConfig.queryIcon);
        elIcon.className = defConfig.icon;
    }
}

// ----------------------------------------------------------------------------

export { create, change };
